//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';

import { createHasFeatureSelector } from '@redux/selectors/createHasFeatureSelector';

// TODO: PD-285229: Remove InstagramEngagementRateUpdate Feature Flag
export const getIsInstagramEngagementRateUpdateEnabled =
  createHasFeatureSelector(FeatureNames.InstagramEngagementRateUpdate);
